import React from 'react';
import { PrimaryButton } from 'components/buttons/Button';
import { ArrowRight } from 'components/Icons/Glyphs';

export default ({ t, onCheckout, disabled, ...props}) => {

    return <PrimaryButton {...{disabled}} className='zt-checkout__controls__checkout' onClick={() => onCheckout && onCheckout()}>{t('buttons.checkout', 'Checkout')} <ArrowRight /></PrimaryButton>
}